import { createContext, useContext } from 'react';

import { ModuleRegistry } from './registry';

export const ModuleRegistryContext = createContext<ModuleRegistry>(new ModuleRegistry([]));

/** All module contributions (nav items, panels, widgets…). */
export const useModuleRegistry = (): ModuleRegistry => useContext(ModuleRegistryContext);

const alwaysAvailable = () => true;

/** Whether a module offers the side panel `type` and has not switched it off (`SidePanelDefinition.useAvailable`). */
export function useSidePanelAvailable(type: string): boolean {
  const registry = useModuleRegistry();
  const definition = registry.getSidePanel(type);
  const useAvailable = definition?.useAvailable ?? alwaysAvailable;
  const available = useAvailable();
  return definition !== undefined && available;
}
